import moment from 'moment';
import { useQuery } from 'react-query';
import PhotographerCalendarApi from '../PhotographerCalendarApi';
import { IPrintEventsResult } from '../Types';

export const PrintEventsQueryKey = 'photographer-calendar-print-events';

type IPrintEventsQueryArgs = {
    from: moment.Moment;
    to: moment.Moment;
    photographerId?: number;
};

export function usePrintEventsQuery({ from, to, photographerId }: IPrintEventsQueryArgs) {
    return useQuery<IPrintEventsResult>(
        [
            PrintEventsQueryKey,
            photographerId === undefined ? 'me' : photographerId,
            from.format('YYYYMMDD'),
            to.format('YYYYMMDD')
        ],
        () => PhotographerCalendarApi.getCalendarPrintEvents(from, to, photographerId),
        { refetchOnWindowFocus: false }
    );
}
